<template>
  <el-row class="tac">
    <el-col class="nav-menu-container">
      <h5
        align="center"
        @click="toHistoryHome(name)"
      >{{ name }}</h5>
      <el-menu
        :unique-opened="true"
        :default-openeds="opened.open"
        class="el-menu-vertical"
        @open="handleOpen"
        @close="handleOpen"
        @select="select"
      >
        <div
          v-for="(item, index) in navList"
          :key="index"
          class="menu-item-container"
        >
          <el-menu-item
            v-if="!item.Data.length"
            :index="index + ''"
            :class="{'el-menu-active': active[0] === index + ''}"
            class="one-level-menu"
          >
            <template slot="title">
              <i class="el-icon-location" />
              <span>{{ item.ShowName }} <span class="count">{{ item.TotalCount }}</span></span>
            </template>
          </el-menu-item>

          <el-submenu
            v-if="item.Data.length"
            :index="index + ''"
            :class="{'el-submenu-active': active[0] === index + ''}"
          >
            <template slot="title">
              <i class="el-icon-location" />
              <span>{{ item.ShowName }} <span class="count">{{ item.TotalCount }}</span></span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                v-for="(child, childIndex) in item.Data"
                :index="index + '-' + childIndex"
                :key="childIndex"
                :class="{'el-menu-active': active[1] && active[1] === childIndex + ''}"
              >
                <span>{{ child.Name }}</span>
                <!-- <span class="count">{{ child.Count }}</span> -->
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </div>

      </el-menu>
    </el-col>
    <div class="bottom-pic">
      <img src="../../assets/img/联系电话-2@2x.png">
      <div><span>0898-68707437</span></div>
      <img src="../../assets/img/主办机构@2x.png">
    </div>
  </el-row>
</template>
<script>
import {mapState} from 'vuex'
export default {
  name: 'NavMenu',
  props: ['nav', 'name', 'opens', 'noRoute'],
  data () {
    return {
      navList: this.nav,
      opened: {
        open: []
      },
      active: []
    }
  },
  computed: {
    ...mapState({
      comeFromOldSystem: 'comeFromOldSystem'
    })
  },
  watch: {
    '$route' () {
      this.setDefaultActive()
    }
  },
  created () {
    this.$set(this.opened, 'open', this.opens)
    this.setDefaultActive()

    // 滚动条设置
    this.$nextTick(() => {
      window.$('.nav-menu-container').mCustomScrollbar({
        axis: 'y', // vertical scrollbar
        scrollbarPosition: 'inner',
        scrollInertia: 500
      })
    })
  },
  destroyed () {
    window.$('.nav-menu-container').mCustomScrollbar('destroy')
  },
  methods: {
    setDefaultActive () {
      if (this.noRoute) {
        return false
      }
      this.active = this.$route.fullPath.split('/')
                    .filter((item, index) => {
                      return index > 1
                    })
    },
    handleOpen (key, keyPath) {
      this.active = key.split('-')
      if (this.noRoute) {
        this.$emit('selectMenu', key)
        return false
      }

      this.$router.push('/' + this.$route.fullPath.split('/')[1] + '/' + key)
    },
    select (key, keyPath) {
      this.active = key.split('-')
      if (this.noRoute) {
        this.$emit('selectMenu', key)
        return false
      }

      let routes = this.$route.fullPath.split('/')
      this.$router.push('/' + routes[1] + '/' + routes[2] + '/' + key.split('-')[1])
    },
    toHistoryHome (name) {
      if (!this.comeFromOldSystem) {
        if (name === '口述库') {
          window.location.href = 'http://www.reformdata.org/orh/'
          return false
        } else if (name === '实物库') {
           window.location.href = 'http://www.reformdata.org/rhn/'
           return false
        }
      }
      this.$router.push('/historyHome')
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/modules/history/nav-menu.vue